import type { ProjectRuntimeSnapshot } from "@/platform/types"

export const runtimePreparationSignature = (snapshot: ProjectRuntimeSnapshot) =>
	JSON.stringify({
		bunLockHash: snapshot.bunLockHash,
		dependencies: snapshot.dependencies,
		jsDependencies: snapshot.jsDependencies,
		jsRuntimeVersion: snapshot.jsRuntimeVersion,
		nodes: snapshot.nodes.map((node) => ({
			code: node.code,
			id: node.id,
			type: node.type,
		})),
		projectID: snapshot.projectID,
		pythonDependencies: snapshot.pythonDependencies,
		pythonVersion: snapshot.pythonVersion,
	})
